import React from "react"

function ChevronUpRounded() {
  return (
    <svg
      width="8"
      height="5"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.77145 0.435338C4.37147 -0.0496155 3.62853 -0.0496156 3.22855 0.435338L1.01946 3.11371C0.481498 3.76595 0.945443 4.75 1.79091 4.75L6.20909 4.75C7.05455 4.75 7.5185 3.76596 6.98054 3.11372L4.77145 0.435338Z" fill="white" />
    </svg>
  )
}

export default ChevronUpRounded